var React = require('react');

function PlayerExpand (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","stroke":"#000","strokeWidth":".75","d":"M10.73 1v2.481h4.01L6 12.322 7.67 14l8.85-8.675V9.27H19V1h-8.27zM1 1v18h18v-7h-2.526v4.473H3.526V3.526h4.316V1H1z"}));
}

PlayerExpand.displayName = "PlayerExpand";

PlayerExpand.defaultProps = {"width":"20","height":"20"};

module.exports = PlayerExpand;

PlayerExpand.default = PlayerExpand;
